"use client";

import React from "react";
import Link from "next/link";
import classes from "./Header.module.scss";
import { useSession } from "@/lib/hooks";
import { Avatar, Dropdown } from "antd";
import type { MenuProps } from "antd";
import Image from "next/image";

const AuthLink = () => {
  const { session, logOut } = useSession();
  const user = session?.user;

  const getInitial = (email: string) => {
    return email ? email.charAt(0).toUpperCase() : "";
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "profile",
      label: <Link href="/profile">Profile</Link>,
    },
    {
      key: "logout",
      label: <span onClick={logOut}>Logout</span>,
    },
  ];

  const imageLink = user?.img?.link;
  const avatarContent = user?.email ? getInitial(user.email) : "";

  return (
    <>
      {"isAuthenticated" in session && session?.isAuthenticated == false ? (
        <Link href={`/login`} className={classes["log-in-link"]}>
          Log in / Sign Up
        </Link>
      ) : (
        <Dropdown
          menu={{ items: menuItems }}
          trigger={["click"]}
          placement="bottomRight"
        >
          {imageLink ? (
            <Image
              src={imageLink}
              width={38}
              height={38}
              alt="profile-pic"
              style={{ cursor: "pointer", borderRadius: "50%" }}
            />
          ) : (
            <Avatar style={{ backgroundColor: "#87d068", cursor: "pointer" }}>
              {avatarContent}
            </Avatar>
          )}
        </Dropdown>
      )}
    </>
  );
};

export default AuthLink;
